import { Injectable } from '@angular/core';

export interface GoogleGeoChart {
    draw(data: unknown, options: {region: string; resolution: string; displayMode: string; backgroundColor: string;
        datalessRegionColor: string; defaultColor: string; colorAxis: {minValue: number; maxValue: number; colors: string[]};
        legend: string; keepAspectRatio: boolean; width: number; height: number}): void;
    clearChart(): void;
}
export interface GoogleGeoApi {
    charts: {load(version: string, settings: {packages: string[]}): void; setOnLoadCallback(callback: () => void): void};
    visualization: {arrayToDataTable(rows: (string | number | {v: string | number; f: string})[][]): unknown;
        GeoChart: new(element: HTMLElement) => GoogleGeoChart};
}

/** Lazy, shared Google loader. ISO US-state codes avoid geocoding and a Maps API key. */
@Injectable({providedIn:'root'})
export class GoogleGeoChartService {
    private _loading: Promise<GoogleGeoApi>;
    load(): Promise<GoogleGeoApi> {
        if (this._loading) return this._loading;
        this._loading = new Promise<GoogleGeoApi>((resolve,reject) => {
            const script = document.createElement('script');
            const timer = setTimeout(() => fail(), 20000);
            const fail = () => {clearTimeout(timer);script.remove();this._loading = undefined;reject(new Error('Map unavailable'));};
            script.src = 'https://www.gstatic.com/charts/loader.js'; script.async = true;
            script.onerror = fail;
            script.onload = () => {
                try {
                    const api = (window as Window & {google?: GoogleGeoApi}).google;
                    if (!api?.charts) {fail();return;}
                    api.charts.load('current',{packages:['geochart']});
                    api.charts.setOnLoadCallback(() => {clearTimeout(timer);resolve(api);});
                } catch {fail();}
            };
            document.head.appendChild(script);
        });
        return this._loading;
    }
}
